import { Box, Typography } from "@mui/material";
import React, { memo } from "react";

function NoDataContent({
  Icon,
  subtitle,
  title,
  height = 300,
  iconSize = "4rem",
  titleSize = "1.5rem",
  component,
  children,
  px = 6,
  subtitleSx,
  titleSx,
  sx
}) {
  return (
    <Box
      component={component}
      px={px}
      height={height}
      display={"flex"}
      alignItems="center"
      justifyContent={"center"}
      flexDirection="column"
      sx={sx}
    >
      {Icon && (
        <Icon color="action" sx={{ fontSize: iconSize, opacity: 0.4, mb: 2 }} />
      )}
      <Typography
        fontWeight={"600"}
        textAlign={"center"}
        fontSize={titleSize}
        color={"text.primary"}
        variant="h5"
        sx={titleSx}
      >
        {title}
      </Typography>
      <Typography
        mt={0.4}
        maxWidth={400}
        textAlign={"center"}
        fontWeight={"500"}
        fontSize={"1rem"}
        component={'div'}
        color={"text.secondary"}
        sx={subtitleSx}
      >
        <div
          dangerouslySetInnerHTML={{
            __html: subtitle,
          }}
        />
      </Typography>
      {Boolean(children) && <Box mt={2}>{children}</Box>}
    </Box>
  );
}

export default memo(NoDataContent);
